import {createApp} from 'vue'
import options from './MenuSecondary.options'
import { useMainStore } from 'stores/main.store'


const scrapeMenuForLinkData = function(MenuSecondaryDOM){

    const megaMenusDOM = MenuSecondaryDOM.querySelectorAll('.be-menu-secondary__menu-list-item')

    const megaMenuData = Array.from(megaMenusDOM).reduce((completeData,currentMegaMenuDOM,index)=>{
       
        const menuItem = currentMegaMenuDOM.querySelector('.be-menu-secondary__menu-item')

        completeData.push({
            displayName: menuItem.textContent.trim(),
            href: menuItem.href ?? null,
            subItems : (!menuItem.href)
                ? Array.from(menuItem.parentNode.querySelectorAll('.be-menu-secondary__dropdown-list a')).reduce((allLinks,linkDOM)=>{
                    allLinks.push({
                        displayName: linkDOM.textContent.trim(),
                        href: linkDOM.href
                    })
                    return allLinks
                },[])
                : null
        })
        
        return completeData
    },[])

    return megaMenuData
}

const shouldMount = function(documentNode){
    // ### this init file is used in the story
    // we are not mounting the component if the documentNode is just a fragment
    // that is not the full document.
    return !(documentNode instanceof DocumentFragment)
}

const el = '.be-component--menu-secondary'

export default function(Store,documentNode = document){
    const DOM = documentNode.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MenuSecondaryDOM)=>{
            const template = MenuSecondaryDOM.innerHTML

            // ### this init file is used in the story
            // we are only assigning the template here if the component is to be mounted.
            // the options are shared, and will unintentionally override the instance controlled by storybook.
            if(shouldMount(documentNode)) options.template = template
            const component = createApp(options).use(Store)
            const mainStore = useMainStore()
            mainStore.setSecondaryMenuMobileData(scrapeMenuForLinkData(MenuSecondaryDOM))

            // ### this init file is used in the story
            // we are only mounting if the document is not a fragment
            if(shouldMount(documentNode)) {
                component.mount(MenuSecondaryDOM)   
            } else {
                console.warn("Component " + el + " is not mounted")
            }
        })
    }
}

